import React, { useContext } from 'react';
import { OrganizationsContext } from '../OrganizationContextProvider';
import { useSearchParams } from 'src/utils/useSearchParams';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import Text from 'src/components/Text';
import LinkButton from 'src/components/LinkButton';
import HelpLink from 'src/components/HelpLink';
import { ORGANIZATION_SHOWCASE_TABS } from '../constants';
import OrganizationBanks from '../OrganizationBanks';
import OrganizationUsers from '../OrganizationUsers';
import classnames from 'classnames';
import styles from './styles.module.scss';
import routes from 'src/constants/routes';

const OrganizationShowcase: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  /* При навигации через Link на странице добавления организации не проходит проверка
        cades plugin и отображается ссылка для установки плагина. Если страницу
        перезагрузить, то проверка проходит и можно перейти к выбору сертификата.
        Причина не ясна. На Портале поведение аналогично и тоже используется внешняя ссылка. */
  const navigate = useNavigate({ browserNavigation: true });
  const { currentOrganization, organizations } = useContext(OrganizationsContext);
  
  const handleAddOrganizationClick = () => {
    navigate(routes.addOrganization);
  }

  if (!organizations || organizations.length === 0) {
    return (
      <div className={styles['placeholder']}>
        <Text type="p" muted>Список организаций пуст. Для продолжения добавьте организацию.</Text>
        <Button onClick={handleAddOrganizationClick} className={styles['add-organization-button']}>
          Добавить организацию
        </Button>
      </div>
    );
  }
  
  if (!currentOrganization) {
    return null;
  }

  const activeTab = searchParams.get('tab') ?? ORGANIZATION_SHOWCASE_TABS.default;

  const organizationBanksClassNames = classnames(styles['tab'], {
    [styles['active-tab']]: activeTab === ORGANIZATION_SHOWCASE_TABS.banks,
  });
  const organizationUsersClassNames = classnames(styles['tab'], {
    [styles['active-tab']]: activeTab === ORGANIZATION_SHOWCASE_TABS.users,
  });

  const handleTabClick = (tab: string) => () => {
    setSearchParams({ tab });
  };

  return (
    <>
      <div className={styles['root']}>
        <div className={styles['title-wrapper']}>
          <div>
            <Text type="h1" className={styles['title']}>
              {currentOrganization.name}
            </Text>
            <Text type="span" muted>ИНН {currentOrganization.inn},</Text>{' '}
            <Text type="span" muted>ОГРН {currentOrganization.ogrn}</Text>
          </div>
          <HelpLink/>
        </div>
        <div>
          <LinkButton
            onClick={handleTabClick(ORGANIZATION_SHOWCASE_TABS.banks)}
            className={organizationBanksClassNames}
          >
            Банки
          </LinkButton>
          <LinkButton
            onClick={handleTabClick(ORGANIZATION_SHOWCASE_TABS.users)}
            className={organizationUsersClassNames}
          >
            Пользователи
          </LinkButton>
        </div>
        <div className={styles['showcase-tab']}>
          {activeTab === ORGANIZATION_SHOWCASE_TABS.banks && <OrganizationBanks />}
          {activeTab === ORGANIZATION_SHOWCASE_TABS.users && <OrganizationUsers />}
        </div>
      </div>
    </>
  );
};

export default OrganizationShowcase;
